import { useTranslate } from "@similarweb/i18n-provider";
import { Box, Stack } from "@similarweb/ui-components/foundations";

import { abbrNumberWithPrefixFilter } from "app/filters/ngFilters";
import { FormFieldLabel, RangeSelectWithFilter } from "app/pages/sales-intelligence/common-components/form-fields";
import type { AppsPriceType } from "app/pages/sales-intelligence/domain/apps/types/filter-values";
import { appsPriceTypeMap } from "app/pages/sales-intelligence/domain/apps/types/filter-values";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import { DOLLAR_PREFIX, RANGE_SELECT_WIDTH } from "../../../constants";
import type FindAppsPriceFilter from "../../../models/PriceFilter/PriceFilter";

import PriceTypeFilter from "./components/PriceTypeFilter/PriceTypeFilter";

const formatNumber = abbrNumberWithPrefixFilter();

const PREFIX = `${DOLLAR_PREFIX} `;

type PriceValueType = number | undefined;

const AppsPriceFilter = ({ filter, value, onFilterUpdate }: IFilterViewBaseProps<FindAppsPriceFilter>) => {
    const { translate } = useTranslate();

    const handleTypeChange = (type?: AppsPriceType) => {
        if (!type) {
            return onFilterUpdate();
        }

        onFilterUpdate({ type });
    };

    const handlePriceChange = ([minValue, maxValue]: PriceValueType[]) => {
        onFilterUpdate({
            type: appsPriceTypeMap.paid,
            priceRange: {
                from: minValue,
                to: maxValue,
            },
        });
    };

    const formatDisplayedValue = (v: number): string => formatNumber(v, PREFIX);

    const range =
        value?.type !== appsPriceTypeMap.paid ? null : (
            <FormFieldLabel text={translate("si.find_apps.filters.price.range.label")}>
                <RangeSelectWithFilter
                    fieldName="price"
                    value={[value?.priceRange?.from, value?.priceRange?.to]}
                    optionsMin={filter.minOptions}
                    optionsMax={filter.maxOptions}
                    placeholderMin={translate("si.find_apps.filters.range.min.placeholder")}
                    placeholderMax={translate("si.find_apps.filters.range.max.placeholder")}
                    formatValue={formatDisplayedValue}
                    onChange={handlePriceChange}
                    width={RANGE_SELECT_WIDTH}
                />
            </FormFieldLabel>
        );

    return (
        <Box width="260px">
            <Stack gap="16px">
                <PriceTypeFilter
                    value={value?.type}
                    options={filter.options.priceTypes}
                    onChange={handleTypeChange}
                />

                {range}
            </Stack>
        </Box>
    );
};

export default AppsPriceFilter;
